export default __webpack_public_path__ + "static/media/Tablyeet-Massad-Logo.126b481c.jpg";